import React, { useState } from "react";
import { Link } from "react-router-dom";
import api, { formatApiErrorDetail } from "@/lib/api";
import { AUTH } from "@/constants/testIds";

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSubmitting(true);
    try {
      await api.post("/auth/forgot-password", { email: email.trim() });
      setSubmitted(true);
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen bg-cream flex items-center justify-center p-6 sm:p-12">
      <div className="w-full max-w-md fade-up">
        <div className="text-center">
          <Link to="/login" className="overline">← Members&rsquo; Portal</Link>
          <h1 className="font-serif text-4xl sm:text-5xl text-[#1A1A1A] mt-3 leading-none">
            Forgot your password?
          </h1>
          <p className="mt-3 text-[#4A4A4A]">
            Enter your members&rsquo; email and we&rsquo;ll send you a one-time link to set a new one.
          </p>
        </div>

        {submitted ? (
          <div
            data-testid={AUTH.successBanner}
            className="mt-10 surface-card p-8 text-center"
          >
            <div className="overline">Check Your Inbox</div>
            <p className="font-serif text-2xl mt-2 text-[#1A1A1A]">A note is on its way.</p>
            <p className="text-sm text-[#4A4A4A] mt-3 leading-relaxed">
              If <span className="font-mono text-[#1A422D]">{email}</span> is on the
              members&rsquo; ledger, you&rsquo;ll receive a reset link shortly. It
              expires in one hour.
            </p>
            <Link to="/login" className="btn-secondary inline-block mt-6">
              Back to Sign In
            </Link>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="mt-10 surface-card p-8">
            {error && (
              <div
                data-testid={AUTH.errorBanner}
                className="mb-5 px-4 py-3 border border-[#A33] bg-[#fbe9e9] text-[#8a1a1a] text-sm"
              >
                {error}
              </div>
            )}
            <label className="label-elegant block mb-2">Email</label>
            <input
              type="email"
              required
              autoComplete="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              data-testid={AUTH.forgotEmail}
              className="input-field"
              placeholder="you@example.com"
            />
            <button
              type="submit"
              disabled={submitting}
              data-testid={AUTH.forgotSubmit}
              className="btn-primary w-full mt-6"
            >
              {submitting ? "Sending…" : "Send Reset Link"}
            </button>
            <p className="mt-6 text-sm text-[#4A4A4A] text-center">
              Remembered it?{" "}
              <Link to="/login" className="text-[#1A422D] underline underline-offset-4">
                Sign in
              </Link>
            </p>
          </form>
        )}
      </div>
    </div>
  );
}
